import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';

export const useGetCustomPolicyFilterDataQuery = () => {
  const isLogin = useAuthStore((state) => !!state.isLogin);

  return useQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/member-filter/required'](),
    enabled: isLogin,
    select: (data) => ({
      filterValues: data.context?.codeList,
      familyCount: data.context?.familyCnt,
      familyIncome: data.context?.salary,
      unemploymentDate: data.context?.unemploymentDate ?? undefined,
    }),
  });
};
